import { getMobileOS, OS_TYPES } from "../../utils/getMobileOS";
import { toast } from "react-toastify";
import { useTranslation } from "next-i18next";

export const useShareAndChat = ({ title, text }) => {
    const { t } = useTranslation();

    const success_notify = (url) =>
        toast.success(`${t("successfully_copied")} ${url}`, {
            position: toast.POSITION.TOP_RIGHT,
        });

    const handleChatClick = () => {
        const os = getMobileOS();
        if (os === OS_TYPES.ANDROID) {
            window.open("https://play.google.com/store/apps/details?id=com.beautycils.app", "_blank");
        } else if (os === OS_TYPES.IOS || os === OS_TYPES.MACOS) {
            window.open("https://apps.apple.com/us/app/beautycils/id1611889051", "_blank");
        } else {
            window.open("https://play.google.com/store/apps/details?id=com.beautycils.app", "_blank");
        }
    };

    const handleShare = async () => {
        const os = getMobileOS();
        const url = window.location.href;
        const isMobile = os === OS_TYPES.ANDROID || os === OS_TYPES.IOS;

        if (navigator.share) {
            try {
                await navigator.share({
                    title,
                    text,
                    url,
                });
            } catch { }
        } else {
            // Фолбэк: опции для копирования и мессенджеров
            // const whatsapp = `https://wa.me/?text=${encodeURIComponent(url)}`;
            // const telegram = `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(name)}`;
            // window.open(whatsapp, "_blank");
            navigator.clipboard.writeText(url);
            success_notify(url);
        }
    };

    return { handleChatClick, handleShare };
};
